import {
    ensureCallbacks as ensureCallbacksFromFrame,
    ensureContext as ensureContextFromFrame,
    getWidgetContextSnapshot,
    resetWidgetContext,
    updateWidgetContext,
    type WidgetContextState,
} from "@kontextwerk/web-sdk/core"

type AssistWindow = typeof window & {
  chatWidgetContext?: Record<string, unknown> | null
  chatWidgetCallbacks?: Record<string, (payload: any) => unknown>
}

export type AssistContextState = WidgetContextState

export const ensureWindow = (): AssistWindow | null => {
  if (typeof window === "undefined") return null

  return window as AssistWindow
}

export const ensureContext = (): Record<string, unknown> | null => ensureContextFromFrame()

export const ensureCallbacks = (): Record<string, (payload: any) => unknown> | null =>
  ensureCallbacksFromFrame()

export const updateAssistContext = (patch: Partial<AssistContextState>): void => {
  updateWidgetContext(patch)
}

export const resetAssistContext = (): void => {
  resetWidgetContext()
}

export const getAssistContextSnapshot = (): AssistContextState => getWidgetContextSnapshot()
